$( document ).ready(function() {

         var swiper = new Swiper(".mySwiper.testimonial-slider", {
        loop:true,
        spaceBetween: 10,
        slidesPerView: 1,
        centeredSlides: true,
         navigation: {
          nextEl: ".testimonial-button-next",
          prevEl: ".testimonial-button-prev",
        },
        autoplay: {
          delay: 2000,
          disableOnInteraction: false,
        },
        speed:1000,
        breakpoints: {
          0: {
            slidesPerView: 1,
          }
        },
    });

   setTimeout(function () {
     var swiper = new Swiper(".relatedSwiper", {
      slidesPerView: 4,
      // spaceBetween: 10,
      freeMode: true,
     loop: false,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },

      navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
      },
        breakpoints: {
          320: {
              slidesPerView: 1,
          },
          750: {
            slidesPerView: 2,
            // spaceBetween: 20,
          },
          1024: {
            slidesPerView: 4,
            // spaceBetween: 20,
          },
        },
       
    });

  }, 3000);

});
